import 'Assets/styles/default/pages/focalPoint/FocalPointManagePointsStyles.less';
import React from 'react';
import {
    VertModal,
    VertButton,
    Typography,
    VertIcon
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';
import { pointsMask } from 'Utils/commons/points';

const UploadSummary = ({ isOpen, onClose, finishUpload, decimalPlaces, pointsName, balance, totalSum }) => {

    const pointsWrapper = (value) => {
        return pointsMask(value, decimalPlaces, pointsName).value;
    }

    return (
        <VertModal
            destroyOnClose={true}
            open={isOpen}
            onCancel={() => {
                onClose();
            }}
            className="container-modal-focal-point-manage modal-terms-aprovation"
        >
            <Row justify={'center'} gutter={[8, 8]}
            >
                <Col span={24} className='mt-16'>
                    <Row justify={'center'}>
                        <VertIcon
                            size="large"
                            className='icon-summary-upload-distribution icon-share-summary-upload-distribution'
                            component={ShareAltOutlined}
                        />
                    </Row>
                </Col>

                <Col span={24} className='mt-16'>
                    <Row justify={'center'}>
                        <Typography.Text strong className="manage-points-details-main">
                            Distribuir pontos:
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24} className='mt-16'>
                    <Row justify={'center'}>
                        <Typography.Text className="manage-points-details-main">
                            Valor disponível para distribuição: {pointsWrapper(balance)}
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24} className='mt-16'>
                    <Row justify={'center'}>
                        <Typography.Text className="manage-points-details-main">
                            Valor adicionado em sua planilha: {pointsWrapper(totalSum)}
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24} className='mt-16'>
                    <div className='modal-upload-divider' />
                </Col>

                <Col span={24} className='mt-16'>
                    <Row justify={'space-around'} gutter={[16, 16]}>
                        <Col span={10}>
                            <VertButton
                                type="highlight"
                                size="default"
                                className='button-historic-redirect button-focal-point width-100'
                                onClick={() => {
                                    finishUpload(false);
                                    onClose();
                                }}
                            >
                                Revisar
                            </VertButton>
                        </Col>

                        <Col span={10}>
                            <VertButton
                                disabled={balance != totalSum}
                                type="highlight"
                                size="default"
                                className='button-historic-redirect button-focal-point width-100'
                                onClick={() => {
                                    finishUpload(true);
                                    onClose();
                                }}
                            >
                                Distribuir
                            </VertButton>
                        </Col>
                    </Row>
                </Col>

            </Row>

        </VertModal >
    );
};

export default UploadSummary;
